var castle = "/static/61f8c4cc2ad98235.png";

export { castle as default };
//# sourceMappingURL=castle.png.js.map
